<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มประเภทการลา</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ leaveTypeInit.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ leaveTypeInit.title_en }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          รหัสประเภทการลา
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="leaveType.leave_type_code"
          :rules="[
            (v) => !!v || 'โปรดระบุรหัสประเภทการลา',
            (v) =>
              (v && v.length >= 1 && v.length <= 32) ||
              'รหัสประเภทการลาต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'leave_type_code')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ชื่อประเภทการลา (ไทย)
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="leaveType.title_th"
          :rules="[
            (v) => !!v || 'โปรดระบุชื่อประเภทการลา',
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อประเภทการลาต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2"> ชื่อประเภทการลา (อังกฤษ) </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="leaveType.title_en"
          :rules="[
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อประเภทการลาต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2">
          จำนวนวันลาสูงสุด
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="5"
          v-model.number="leaveType.day_limit"
          :rules="[
            (v) => !!v || 'โปรดระบุจำนวนวันลาสูงสุด',
            (v) => !v || /^\d+$/.test(v) || 'ใส่ได้เฉพาะตัวเลข',
          ]"
          clearable
          outlined
          dense
        ></v-text-field>
        <label class="body-2"> เพศชาย </label>
        <v-switch
          tabindex="4"
          class="mt-0"
          v-model="leaveType.is_male"
        ></v-switch>
        <label class="body-2"> เพศหญิง </label>
        <v-switch
          tabindex="5"
          class="mt-0"
          v-model="leaveType.is_female"
        ></v-switch>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isLeaveTypeDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::leave_type:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::leave_type:create')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::leave_type:update')"
            tabindex="4"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    leaveType: {
      type: Object,
    },
    leaveTypeInit: {
      type: Object,
    },
  },
  data() {
    return {
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isLeaveTypeDataChange() {
      if (
        this.leaveType.leave_type_code !== this.leaveTypeInit.leave_type_code ||
        this.leaveType.title_th !== this.leaveTypeInit.title_th ||
        this.leaveType.title_en !== this.leaveTypeInit.title_en ||
        this.leaveType.day_limit !== this.leaveTypeInit.day_limit ||
        this.leaveType.is_male !== this.leaveTypeInit.is_male ||
        this.leaveType.is_female !== this.leaveTypeInit.is_female
      ) {
        this.$emit('isLeaveTypeDataChange', true)
        return true
      }
      this.$emit('isLeaveTypeDataChange', false)
      return false
    },
  },
  methods: {
    ...mapActions({
      addLeaveType: 'leaveType/addLeaveType',
      editLeaveType: 'leaveType/editLeaveType',
      deleteLeaveType: 'leaveType/deleteLeaveType',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.leaveType[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบประเภทการลา',
        value: this.leaveType.title_th,
        item: this.leaveType,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    submitConfirmDialogDelete(leaveType) {
      this.confirmDialogDeleteLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.deleteLeaveType({
        company_uuid,
        leave_type_uuid: leaveType.leave_type_uuid,
      })
        .then(() => {
          this.confirmDialogDeleteLoading = false
          this.confirmDialogDelete = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.$refs.form.resetValidation()
          this.$emit('formActionCompleted', this.formAction)
          // this.$refs.form.reset()
        })
        .catch((error) => {
          this.confirmDialogDeleteLoading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          body: {
            ...this.leaveType,
            day_limit: parseInt(this.leaveType.day_limit, 10),
            date_before_leave: 0,
            date_after_leave: 0,
            is_male: this.leaveType.is_male ? this.leaveType.is_male : false,
            is_female: this.leaveType.is_female
              ? this.leaveType.is_female
              : false,
          },
        }

        this.addLeaveType(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction, this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const leaveType = {
          ...this.leaveType,
          day_limit: parseInt(this.leaveType.day_limit, 10),
        }

        this.editLeaveType({
          company_uuid,
          leave_type_uuid: this.leaveType.leave_type_uuid,
          body: leaveType,
        })
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$emit('formActionCompleted', this.formAction)
            // this.$refs.form.reset()
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onClose() {
      if (this.isLeaveTypeDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$emit('formActionCompleted', this.formAction)
        // this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      this.$emit('formActionCompleted', this.formAction)
      // this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.$refs.form.resetValidation()
        // this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
